import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const TypeMasterCategory = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const [typeMasterCategoryEntries, setTypeMasterCategoryEntries] =
        useState(initialEntries);
    const [typeMasterCategoryPageIndex, setTypeMasterCategoryPageIndex] =
        useState(initialPage - 1);
    const [search, setSearch] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");

    const { useFetch } = useAPIQuery({
        key: "api/type-master-category",
        endpoint: "/api/type-master-category/",
    });

    const { data, isLoading, isFetching } = useFetch({
        params: {
            entries: typeMasterCategoryEntries,
            page_no: typeMasterCategoryPageIndex + 1,
            event: search ? search : undefined,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useDelete } = useAPIQuery({
        key: "api/type-master-category",
        endpoint: "/api/type-master-category/",
    });

    const { mutate: deleteData } = useDelete();

    const handleTypeMasterCategorySelect = (category) => {
        sessionStorage.setItem("TMCategory", JSON.stringify(category));
        navigate("/type-master");
    };

    const columns = [
        {
            accessor: "category_name",
            header: "Type Master Category Display Name",
            cell: (row) => (
                <a
                    className="link"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleTypeMasterCategorySelect(row)}
                >
                    {row?.category_name}
                </a>
            ),
        },
        {
            accessor: "category_value",
            header: "Type Master Category Name",
        },
        {
            accessor: "description",
            header: "Description",
        },
    ];

    const handleGlobalFilterChange = (value) => {
        console.log(value);
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handlePagination = (value) => {
        console.log(value);
        setSearchParams({
            entries: value.pageSize,
            page: value.pageIndex + 1,
        });
        setTypeMasterCategoryPageIndex(value.pageIndex);
        setTypeMasterCategoryEntries(value.pageSize);
    };

    const handleEditRow = (row) => {
        console.log(row);
        navigate("/edit-type-master-category", {
            state: { editpost: row.original },
        });
    };

    const handleDeleteRow = (row) => {
        console.log(row);
        const entry_id = row.original.id;
        Swal.fire({
            text: "Are you sure? You will not be able to recover this data!",
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No, cancel!`,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteData({ id: entry_id });
            }
        });
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Type Master Category
                        </h3>
                        {/* {isLoading ? (
                            <div
                                className="spinner-border text-primary ms-2"
                                role="status"
                            >
                                <span className="sr-only"></span>
                            </div>
                        ) : (
                            ""
                        )} */}
                    </div>
                    {privileges.includes("type_master_category_create") && (
                        <div className="nk-block-head-content">
                            <NavLink
                                to="/create-type-master-category"
                                className="toggle btn btn-icon btn-primary d-md-none"
                                id="button-button-create-typemaster"
                            >
                                <em className="icon ni ni-plus"></em>
                            </NavLink>

                            <NavLink
                                to="/create-type-master-category"
                                className="toggle btn btn-primary d-none d-md-inline-flex"
                                id="button-button-create-typemaster"
                            >
                                <em className="icon ni ni-plus"></em>
                                <span>Create Type Master Category</span>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>

            <Table
                data={data ? data?.results?.data : []}
                columns={columns}
                pagination
                pageIndex={typeMasterCategoryPageIndex}
                pageSize={typeMasterCategoryEntries}
                rowCount={data ? data.count : 0}
                isLoading={isLoading || isFetching}
                globalSearch
                editRows={
                    privileges.includes("type_master_category_update")
                        ? true
                        : false
                }
                deleteRows={
                    privileges.includes("type_master_category_delete")
                        ? true
                        : false
                }
                filterModal={false}
                selectRows={false}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onRowEdit={handleEditRow}
                onRowDelete={handleDeleteRow}
                onPaginationChange={handlePagination}
            />
        </>
    );
};

export default TypeMasterCategory;
